<template>
  <div class="dashboard-contenedor">
    <SlideBar @cambiar-estado="actualizarSidebar" />

    <div class="contenido" :class="{ 'contenido-expandido': sidebarCerrado }">
      <div class="form-inner">

      <div class="page-header">
        <h2 class="titulo">{{ tituloFormulario }}</h2>
        <p class="subtitulo">Completa todos los campos obligatorios <span class="req">*</span></p>
      </div>

      <form @submit.prevent="enviarFormulario" novalidate>

        <!-- ══ IDENTIFICACIÓN ══════════════════════════════════ -->
        <div class="seccion-card">
          <div class="seccion-header">
            <span class="material-icons">badge</span>
            <h3>Identificación</h3>
          </div>
          <div class="seccion-body">
            <div class="campo-grid id-grid">
              <div class="campo" :class="estadoCampo('folio')">
                <label>Folio <span class="req">*</span></label>
                <input v-model.trim="formulario.folio" type="text" maxlength="30"
                  placeholder="FOL-2024-001"
                  @blur="tocar('folio')" @input="validarCampo('folio')">
                <span class="error-msg">{{ errores.folio }}</span>
              </div>
              <div class="campo" :class="estadoCampo('fecha')">
                <label>Fecha <span class="req">*</span></label>
                <input v-model="formulario.fecha" type="date"
                  @blur="tocar('fecha')" @change="validarCampo('fecha')">
                <span class="error-msg">{{ errores.fecha }}</span>
              </div>
              <div class="campo">
                <label>Hotel / Aliado</label>
                <select v-model="formulario.hotel">
                  <option value="">Sin asignar</option>
                  <option v-for="h in hoteles" :key="h.id" :value="h.id">{{ h.nombre }}</option>
                </select>
              </div>
              <div class="campo" :class="estadoCampo('idioma')">
                <label>Idioma <span class="req">*</span></label>
                <div class="campo-con-boton">
                  <select v-model="formulario.idioma" @blur="tocar('idioma')" @change="validarCampo('idioma')">
                    <option value="" disabled>Seleccionar…</option>
                    <option v-for="i in idiomas" :key="i" :value="i">{{ i }}</option>
                  </select>
                  <button type="button" class="btn-icono-inline" title="Agregar idioma" @click="mostrarNuevoIdioma = !mostrarNuevoIdioma">
                    <span class="material-icons">add</span>
                  </button>
                </div>
                <div v-if="mostrarNuevoIdioma" class="campo-con-boton nuevo-idioma">
                  <input v-model.trim="nuevoIdioma" type="text" maxlength="30" placeholder="Nuevo idioma…" @keyup.enter="agregarIdioma">
                  <button type="button" class="btn-icono-inline" title="Guardar idioma" @click="agregarIdioma">
                    <span class="material-icons">check</span>
                  </button>
                </div>
                <span class="error-msg">{{ errores.idioma }}</span>
              </div>
              <div class="campo">
                <label>Tipo de paciente <span class="req">*</span></label>
                <select v-model="formulario.tipo_paciente">
                  <option value="huesped">Huésped</option>
                  <option value="colaborador">Colaborador</option>
                </select>
              </div>
            </div>
          </div>
        </div>

        <!-- ══ DATOS PERSONALES ════════════════════════════════ -->
        <div class="seccion-card">
          <div class="seccion-header">
            <span class="material-icons">person</span>
            <h3>Datos Personales</h3>
          </div>
          <div class="seccion-body">
            <div class="campo-grid campo-cols-3">
              <div class="campo" :class="estadoCampo('nombre')">
                <label>Nombre <span class="req">*</span></label>
                <input v-model.trim="formulario.nombre" type="text" maxlength="50"
                  @blur="tocar('nombre')" @input="validarCampo('nombre')">
                <span class="error-msg">{{ errores.nombre }}</span>
              </div>
              <div class="campo" :class="estadoCampo('apellido_paterno')">
                <label>Apellido Paterno <span class="req">*</span></label>
                <input v-model.trim="formulario.apellido_paterno" type="text" maxlength="50"
                  @blur="tocar('apellido_paterno')" @input="validarCampo('apellido_paterno')">
                <span class="error-msg">{{ errores.apellido_paterno }}</span>
              </div>
              <div class="campo" :class="estadoCampo('apellido_materno')">
                <label>Apellido Materno</label>
                <input v-model.trim="formulario.apellido_materno" type="text" maxlength="50"
                  @blur="tocar('apellido_materno')" @input="validarCampo('apellido_materno')">
                <span class="error-msg">{{ errores.apellido_materno }}</span>
              </div>
            </div>
            <div class="campo-grid personal-grid">
              <div class="campo" :class="estadoCampo('edad')">
                <label>Edad <span class="req">*</span></label>
                <input v-model.number="formulario.edad" type="number" min="0" max="120"
                  placeholder="0–120"
                  @blur="tocar('edad')" @input="validarCampo('edad')">
                <span class="error-msg">{{ errores.edad }}</span>
              </div>
              <div class="campo" :class="estadoCampo('genero')">
                <label>Género <span class="req">*</span></label>
                <select v-model="formulario.genero"
                  @blur="tocar('genero')" @change="validarCampo('genero')">
                  <option value="" disabled>Seleccionar…</option>
                  <option value="Masculino">Masculino</option>
                  <option value="Femenino">Femenino</option>
                  <option value="Otro">Otro</option>
                </select>
                <span class="error-msg">{{ errores.genero }}</span>
              </div>
              <div class="campo" :class="estadoCampo('pais')">
                <label>País <span class="req">*</span></label>
                <input v-model.trim="formulario.pais" type="text" maxlength="50"
                  placeholder="México"
                  @blur="tocar('pais')" @input="validarCampo('pais')">
                <span class="error-msg">{{ errores.pais }}</span>
              </div>
              <div class="campo" :class="estadoCampo('telefono')">
                <label>Teléfono <span class="req">*</span></label>
                <input v-model.trim="formulario.telefono" type="tel" maxlength="15"
                  placeholder="10 dígitos"
                  @blur="tocar('telefono')" @input="soloDigitos('telefono')">
                <span class="hint-msg">Solo dígitos, 7–15 caracteres</span>
                <span class="error-msg">{{ errores.telefono }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- ══ SIGNOS VITALES (solo perfil médico) ═════════════ -->
        <div class="seccion-card" v-if="perfilActual === 'doctor'">
          <div class="seccion-header">
            <span class="material-icons">favorite</span>
            <h3>Signos Vitales</h3>
          </div>
          <div class="seccion-body">
            <div class="vitales-grid">
              <div class="vital-card" :class="estadoCampo('presion')">
                <span class="material-icons vital-icon">compress</span>
                <label>Presión Arterial</label>
                <input v-model.trim="formulario.presion" type="text" maxlength="10"
                  placeholder="120/80"
                  @blur="tocar('presion')" @input="validarCampo('presion')">
                <span class="hint-msg">sistólica/diastólica</span>
                <span class="error-msg">{{ errores.presion }}</span>
              </div>
              <div class="vital-card" :class="estadoCampo('frecuencia')">
                <span class="material-icons vital-icon">monitor_heart</span>
                <label>Frecuencia Cardíaca</label>
                <input v-model.number="formulario.frecuencia" type="number" min="20" max="300"
                  placeholder="60–100"
                  @blur="tocar('frecuencia')" @input="validarCampo('frecuencia')">
                <span class="hint-msg">BPM</span>
                <span class="error-msg">{{ errores.frecuencia }}</span>
              </div>
              <div class="vital-card" :class="estadoCampo('temperatura')">
                <span class="material-icons vital-icon">thermostat</span>
                <label>Temperatura</label>
                <input v-model.number="formulario.temperatura" type="number" step="0.1" min="30" max="45"
                  placeholder="36.5"
                  @blur="tocar('temperatura')" @input="validarCampo('temperatura')">
                <span class="hint-msg">°C</span>
                <span class="error-msg">{{ errores.temperatura }}</span>
              </div>
              <div class="vital-card" :class="estadoCampo('saturacion')">
                <span class="material-icons vital-icon">air</span>
                <label>Saturación O₂</label>
                <input v-model.number="formulario.saturacion" type="number" min="0" max="100"
                  placeholder="95–100"
                  @blur="tocar('saturacion')" @input="validarCampo('saturacion')">
                <span class="hint-msg">%</span>
                <span class="error-msg">{{ errores.saturacion }}</span>
              </div>
              <!-- NUEVO: frecuencia respiratoria -->
              <div class="vital-card" :class="estadoCampo('frecuencia_respiratoria')">
                <span class="material-icons vital-icon">monitor_heart</span>
                <label>Frecuencia Respiratoria</label>
                <input v-model.number="formulario.frecuencia_respiratoria" type="number" min="0" max="60"
                  placeholder="12–20"
                  @blur="tocar('frecuencia_respiratoria')" @input="validarCampo('frecuencia_respiratoria')">
                <span class="hint-msg">respiraciones/min</span>
                <span class="error-msg">{{ errores.frecuencia_respiratoria }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- ══ DATOS ANTROPOMÉTRICOS (solo nutriólogo) ═════════ -->
        <div class="seccion-card" v-if="perfilActual === 'nutriologo'">
          <div class="seccion-header">
            <span class="material-icons">monitor_weight</span>
            <h3>Datos Antropométricos</h3>
          </div>
          <div class="seccion-body">
            <div class="vitales-grid">
              <div class="vital-card">
                <span class="material-icons vital-icon">scale</span>
                <label>Peso</label>
                <input v-model.number="formulario.peso" type="number" step="0.1" min="0" max="400" placeholder="70">
                <span class="hint-msg">kg</span>
              </div>
              <div class="vital-card">
                <span class="material-icons vital-icon">height</span>
                <label>Talla</label>
                <input v-model.number="formulario.talla" type="number" step="0.1" min="0" max="250" placeholder="170">
                <span class="hint-msg">cm</span>
              </div>
              <div class="vital-card">
                <span class="material-icons vital-icon">functions</span>
                <label>IMC</label>
                <input :value="imc" type="text" readonly>
                <span class="hint-msg">calculado</span>
              </div>
            </div>
            <div class="campo">
              <label>Objetivo nutricional</label>
              <select v-model="formulario.objetivo_nutricional">
                <option value="">Seleccionar…</option>
                <option value="Bajar de peso">Bajar de peso</option>
                <option value="Subir de peso">Subir de peso</option>
                <option value="Mantener peso">Mantener peso</option>
                <option value="Mejorar hábitos alimenticios">Mejorar hábitos alimenticios</option>
                <option value="Otro">Otro</option>
              </select>
            </div>
          </div>
        </div>

        <!-- ══ EVALUACIÓN PSICOLÓGICA (solo psicólogo) ═════════ -->
        <div class="seccion-card" v-if="perfilActual === 'psicologo'">
          <div class="seccion-header">
            <span class="material-icons">psychology</span>
            <h3>Evaluación Psicológica</h3>
          </div>
          <div class="seccion-body">
            <div class="campo">
              <label>Motivo de consulta</label>
              <textarea v-model.trim="formulario.motivo_consulta" maxlength="2000"
                placeholder="Motivo por el que solicita atención…"></textarea>
            </div>
            <div class="campo-grid campo-cols-2">
              <div class="campo">
                <label>Estado de ánimo</label>
                <select v-model="formulario.estado_animo">
                  <option value="">Seleccionar…</option>
                  <option value="Estable">Estable</option>
                  <option value="Ansioso">Ansioso</option>
                  <option value="Deprimido">Deprimido</option>
                  <option value="Irritable">Irritable</option>
                  <option value="Otro">Otro</option>
                </select>
              </div>
              <div class="campo">
                <label>Nivel de riesgo</label>
                <select v-model="formulario.nivel_riesgo">
                  <option value="">Seleccionar…</option>
                  <option value="Bajo">Bajo</option>
                  <option value="Medio">Medio</option>
                  <option value="Alto">Alto</option>
                </select>
              </div>
            </div>
          </div>
        </div>

        <!-- ══ ANTECEDENTES ════════════════════════════════════ -->
        <div class="seccion-card">
          <div class="seccion-header">
            <span class="material-icons">history</span>
            <h3>Antecedentes</h3>
          </div>
          <div class="seccion-body">
            <div class="campo-grid campo-cols-3">
              <div class="campo">
                <label>Enfermedades Previas</label>
                <input v-model.trim="formulario.enfermedades" type="text" maxlength="1000"
                  placeholder="Diabetes, hipertensión…">
              </div>
              <div class="campo">
                <label>Alergias</label>
                <input v-model.trim="formulario.alergias" type="text" maxlength="1000"
                  placeholder="Penicilina, látex…">
              </div>
              <div class="campo">
                <label>Medicación Actual</label>
                <input v-model.trim="formulario.medicacion" type="text" maxlength="1000"
                  placeholder="Metformina 500mg…">
              </div>
            </div>
          </div>
        </div>

        <!-- ══ SERVICIOS ADICIONALES (solo perfil médico) ═════ -->
        <div class="seccion-card" v-if="perfilActual === 'doctor'">
          <div class="seccion-header">
            <span class="material-icons">medical_services</span>
            <h3>Servicios Adicionales</h3>
          </div>
          <div class="seccion-body">
            <div class="servicios-grid">
              <label v-for="s in serviciosAdicionales" :key="s.clave" class="servicio-item">
                <input type="checkbox" :value="s.clave" v-model="formulario.servicios_adicionales">
                <span class="servicio-concepto">{{ s.concepto }}</span>
              </label>
            </div>
          </div>
        </div>

        <!-- ══ DIAGNÓSTICO Y OBSERVACIONES ════════════════════ -->
        <div class="seccion-card">
          <div class="seccion-header">
            <span class="material-icons">assignment</span>
            <h3>{{ perfilActual === 'nutriologo' ? 'Plan Nutricional' : perfilActual === 'psicologo' ? 'Plan Terapéutico' : 'Diagnóstico y Observaciones' }}</h3>
          </div>
          <div class="seccion-body">
            <div class="campo" v-if="perfilActual === 'doctor'">
              <label>Síntomas</label>
              <textarea v-model.trim="formulario.sintomas" maxlength="5000"
                placeholder="Describa los síntomas del paciente…"></textarea>
              <span class="char-count">{{ formulario.sintomas.length }}/5000</span>
            </div>
            <div class="campo">
              <label>{{ perfilActual === 'nutriologo' ? 'Plan alimenticio' : perfilActual === 'psicologo' ? 'Plan terapéutico' : 'Diagnóstico' }}</label>
              <textarea v-model.trim="formulario.diagnostico" maxlength="5000"
                :placeholder="perfilActual === 'nutriologo' ? 'Plan alimenticio sugerido…' : perfilActual === 'psicologo' ? 'Plan terapéutico sugerido…' : 'Diagnóstico médico…'"></textarea>
              <span class="char-count">{{ formulario.diagnostico.length }}/5000</span>
            </div>
            <div class="campo">
              <label>Observaciones</label>
              <textarea v-model.trim="formulario.observaciones" maxlength="5000"
                placeholder="Observaciones adicionales…"></textarea>
              <span class="char-count">{{ formulario.observaciones.length }}/5000</span>
            </div>
          </div>
        </div>

        <!-- ══ ACCIÓN ══════════════════════════════════════════ -->
        <div class="form-footer">
          <button type="submit" class="btn-submit" :disabled="enviando">
            <span class="material-icons">save</span>
            {{ enviando ? 'Registrando…' : 'Registrar Consulta' }}
          </button>
        </div>

      </form>
      </div><!-- /form-inner -->
    </div>
  </div>
</template>

<script>
import SlideBar from '@/components/SlideBar.vue';
import Swal from 'sweetalert2';
import DOMPurify from 'dompurify';
import { addConsulta, getMe, getHoteles, getIdiomas, addIdioma, SERVICIOS_ADICIONALES } from '@/utils/api';

const SOLO_LETRAS = /^[a-zA-ZáéíóúÁÉÍÓÚüÜñÑ\s'-]+$/;
const PRESION_FMT = /^\d{2,3}\/\d{2,3}$/;
const PERFILES_SIN_VITALES = ['nutriologo', 'psicologo'];

function formularioVacio(hoy) {
  return {
    folio: '', fecha: hoy,
    hotel: '',
    idioma: '',
    tipo_paciente: 'huesped',
    nombre: '', apellido_paterno: '', apellido_materno: '',
    edad: '', genero: '', pais: '', telefono: '',
    presion: '', frecuencia: '', temperatura: '', saturacion: '',
    frecuencia_respiratoria: '',
    // Nutriólogo
    peso: '', talla: '', objetivo_nutricional: '',
    // Psicólogo
    motivo_consulta: '', estado_animo: '', nivel_riesgo: '',
    enfermedades: '', alergias: '', medicacion: '',
    sintomas: '', diagnostico: '', observaciones: '',
    servicios_adicionales: [],
  };
}

export default {
  name: 'RegistroConsultas',
  components: { SlideBar },
  data() {
    const hoy = new Date().toISOString().split('T')[0];
    return {
      sidebarCerrado: false,
      enviando: false,
      tocados: {},
      errores: {},
      hoteles: [],
      idiomas: [],
      mostrarNuevoIdioma: false,
      nuevoIdioma: '',
      usuarioActual: null,
      formulario: formularioVacio(hoy),
      serviciosAdicionales: SERVICIOS_ADICIONALES,
    };
  },
  computed: {
    perfilActual() {
      const rango = this.usuarioActual?.rango;
      return PERFILES_SIN_VITALES.includes(rango) ? rango : 'doctor';
    },
    tituloFormulario() {
      if (this.perfilActual === 'nutriologo') return 'Registro de Consulta — Nutrición';
      if (this.perfilActual === 'psicologo') return 'Registro de Consulta — Psicología';
      return 'Registro de Consulta Médica';
    },
    imc() {
      const peso = Number(this.formulario.peso);
      const tallaM = Number(this.formulario.talla) / 100;
      if (!peso || !tallaM) return '';
      return (peso / (tallaM * tallaM)).toFixed(1);
    },
  },
  async mounted() {
    if (localStorage.getItem('tipo_sesion') === 'hotel') {
      this.$router.push('/panel-hotel');
      return;
    }
    const [me, idiomas] = await Promise.all([getMe(), getIdiomas()]);
    this.usuarioActual = me.usuario;
    this.idiomas = idiomas;
    this.cargarHoteles();
  },
  methods: {
    actualizarSidebar(estado) { this.sidebarCerrado = estado; },

    async cargarHoteles() {
      const lista = await getHoteles();
      this.hoteles = (lista || []).filter(h => h.activo === true || h.activo === 1 || h.activo === '1');
    },

    async agregarIdioma() {
      if (!this.nuevoIdioma) return;
      this.idiomas = await addIdioma(this.nuevoIdioma);
      this.formulario.idioma = this.nuevoIdioma;
      this.nuevoIdioma = '';
      this.mostrarNuevoIdioma = false;
    },

    tocar(campo) {
      this.tocados[campo] = true;
      this.validarCampo(campo);
    },

    soloDigitos(campo) {
      this.formulario[campo] = this.formulario[campo].replace(/\D/g, '');
      this.validarCampo(campo);
    },

    validarCampo(campo) {
      const f = this.formulario;
      let msg = '';
      switch (campo) {
        case 'folio':
          if (!f.folio) msg = 'El folio es obligatorio.';
          else if (f.folio.length < 2) msg = 'Mínimo 2 caracteres.';
          break;
        case 'fecha':
          if (!f.fecha) msg = 'La fecha es obligatoria.';
          break;
        // NUEVO: validación de idioma
        case 'idioma':
          if (!f.idioma) msg = 'Seleccione un idioma.';
          break;
        case 'nombre':
          if (!f.nombre) msg = 'El nombre es obligatorio.';
          else if (!SOLO_LETRAS.test(f.nombre)) msg = 'Solo letras y espacios.';
          break;
        case 'apellido_paterno':
          if (!f.apellido_paterno) msg = 'El apellido paterno es obligatorio.';
          else if (!SOLO_LETRAS.test(f.apellido_paterno)) msg = 'Solo letras y espacios.';
          break;
        case 'apellido_materno':
          if (f.apellido_materno && !SOLO_LETRAS.test(f.apellido_materno))
            msg = 'Solo letras y espacios.';
          break;
        case 'edad':
          if (f.edad === '' || f.edad === null) msg = 'La edad es obligatoria.';
          else if (!Number.isInteger(Number(f.edad))) msg = 'Debe ser un número entero.';
          else if (f.edad < 0 || f.edad > 120) msg = 'Rango válido: 0–120 años.';
          break;
        case 'genero':
          if (!f.genero) msg = 'Seleccione un género.';
          break;
        case 'pais':
          if (!f.pais) msg = 'El país es obligatorio.';
          else if (!SOLO_LETRAS.test(f.pais)) msg = 'Solo letras y espacios.';
          break;
        case 'telefono':
          if (!f.telefono) msg = 'El teléfono es obligatorio.';
          else if (!/^\d{7,15}$/.test(f.telefono)) msg = 'Entre 7 y 15 dígitos.';
          break;
        case 'presion':
          if (f.presion && !PRESION_FMT.test(f.presion)) msg = 'Formato: 120/80';
          break;
        case 'frecuencia':
          if (f.frecuencia !== '' && (f.frecuencia < 20 || f.frecuencia > 300))
            msg = 'Rango válido: 20–300 BPM.';
          break;
        case 'temperatura':
          if (f.temperatura !== '' && (f.temperatura < 30 || f.temperatura > 45))
            msg = 'Rango válido: 30–45 °C.';
          break;
        case 'saturacion':
          if (f.saturacion !== '' && (f.saturacion < 0 || f.saturacion > 100))
            msg = 'Rango válido: 0–100%.';
          break;
        // NUEVO: validación de frecuencia respiratoria
        case 'frecuencia_respiratoria':
          if (f.frecuencia_respiratoria !== '' && (f.frecuencia_respiratoria < 0 || f.frecuencia_respiratoria > 60))
            msg = 'Rango válido: 0–60 respiraciones/min.';
          break;
      }
      this.errores = { ...this.errores, [campo]: msg };
    },

    estadoCampo(campo) {
      if (!this.tocados[campo]) return '';
      return this.errores[campo] ? 'campo-error' : 'campo-valido';
    },

    validarTodo() {
      // Agregamos 'idioma' y 'frecuencia_respiratoria' a los campos a validar (idioma obligatorio, frecuencia opcional)
      const obligatorios = ['folio', 'fecha', 'idioma', 'nombre', 'apellido_paterno', 'edad', 'genero', 'pais', 'telefono'];
      const todos = [...obligatorios, 'apellido_materno', 'presion', 'frecuencia', 'temperatura', 'saturacion', 'frecuencia_respiratoria'];
      todos.forEach(c => { this.tocados[c] = true; this.validarCampo(c); });
      return todos.every(c => !this.errores[c]);
    },

    sanitizarDatos(formulario) {
      const limpio = {};
      for (const campo in formulario) {
        const valor = formulario[campo];
        limpio[campo] = typeof valor === 'string'
          ? Array.from(DOMPurify.sanitize(valor)).filter(c => c.charCodeAt(0) > 0x1F && c.charCodeAt(0) !== 0x7F).join('')
          : valor;
      }
      return limpio;
    },

    async enviarFormulario() {
      if (this.enviando) return;
      if (!this.validarTodo()) {
        Swal.fire('Formulario incompleto', 'Corrige los campos marcados en rojo.', 'warning');
        return;
      }

      this.enviando = true;
      const datosLimpios = this.sanitizarDatos(this.formulario);
      const hotelElegido = this.hoteles.find(h => String(h.id) === String(datosLimpios.hotel));
      const datos = { ...datosLimpios, nombre_hotel: hotelElegido ? hotelElegido.nombre : '' };
      try {
        await addConsulta(datos);
        sessionStorage.setItem('ultimaConsulta', JSON.stringify(datosLimpios));
        this.$router.push(`/consulta/${this.formulario.folio}`);
        this.resetFormulario();
      } catch (err) {
        Swal.fire('Error', err.message || 'No se pudo guardar la consulta', 'error');
      } finally {
        this.enviando = false;
      }
    },

    resetFormulario() {
      const hoy = new Date().toISOString().split('T')[0];
      this.formulario = formularioVacio(hoy);
      this.tocados = {};
      this.errores = {};
    },
  },
};
</script>

<style scoped>
/* ---------- LAYOUT ---------- */
.dashboard-contenedor {
  display: flex;
  min-height: 100vh;
  background: var(--brand-beige);
}

.contenido {
  flex-grow: 1;
  padding: 28px 32px;
  margin-left: 250px;
  transition: margin-left 0.3s ease;
}

.contenido-expandido { margin-left: 80px; }

.form-inner {
  max-width: 860px;
  margin: 0 auto;
}

form { width: 100%; }

/* ---------- HEADER ---------- */
.page-header {
  margin-bottom: 24px;
}

.titulo {
  font-size: 26px;
  font-weight: 700;
  color: var(--brand-primary);
  margin: 0 0 4px;
}

.subtitulo {
  font-size: 13px;
  color: var(--brand-secondary-light);
  margin: 0;
}

/* ---------- SECCIÓN CARDS ---------- */
.seccion-card {
  background: var(--white);
  border-radius: 14px;
  box-shadow: 0 2px 12px rgba(19, 62, 104, 0.08);
  margin-bottom: 16px;
  overflow: hidden;
}

.seccion-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px 20px;
  background: var(--brand-primary);
  color: var(--white);
}

.seccion-header .material-icons { font-size: 20px; opacity: 0.9; }

.seccion-header h3 {
  margin: 0;
  font-size: 15px;
  font-weight: 700;
  color: var(--white);
  letter-spacing: 0.2px;
}

.seccion-body {
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

/* ---------- CAMPOS GRID ---------- */
.campo-grid {
  display: grid;
  gap: 16px;
  width: 100%;
}

.campo-cols-2 { grid-template-columns: repeat(2, 1fr); }
.campo-cols-3 { grid-template-columns: repeat(3, 1fr); }

/* Identificación: Folio fijo · Fecha fijo · Hotel flexible */
.id-grid { grid-template-columns: repeat(auto-fit, minmax(160px, 1fr)); }

.campo-con-boton {
  display: flex;
  gap: 6px;
  align-items: stretch;
}

.campo-con-boton select,
.campo-con-boton input {
  flex: 1;
}

.btn-icono-inline {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  border: 2px solid var(--brand-secondary-light);
  background: var(--white);
  border-radius: 8px;
  color: var(--brand-accent-sage);
  cursor: pointer;
  transition: background 0.2s, border-color 0.2s;
}

.btn-icono-inline:hover {
  background: rgba(96, 127, 112, 0.1);
  border-color: var(--brand-accent-sage);
}

.nuevo-idioma { margin-top: 6px; }

/* Datos personales fila 2: Edad estrecho · Género · País flexible · Teléfono */
.personal-grid { grid-template-columns: 90px 150px 1fr 160px; }

.campo {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

label {
  font-size: 13px;
  font-weight: 600;
  color: var(--brand-secondary);
}

.req { color: #e03131; margin-left: 2px; }

input, select, textarea {
  width: 100%;
  padding: 9px 12px;
  border: 2px solid var(--brand-secondary-light);
  border-radius: 8px;
  font-size: 14px;
  color: var(--brand-secondary);
  background: var(--white);
  transition: border-color 0.25s, box-shadow 0.25s;
  box-sizing: border-box;
}

input:focus, select:focus, textarea:focus {
  outline: none;
  border-color: var(--brand-accent-sage);
  box-shadow: 0 0 0 3px rgba(96, 127, 112, 0.18);
}

input::placeholder, textarea::placeholder { color: var(--brand-secondary-light); font-weight: 400; }

select {
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath d='M1 1l5 5 5-5' stroke='%23999' stroke-width='2' fill='none' stroke-linecap='round'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 12px center;
  padding-right: 36px;
  cursor: pointer;
}

textarea {
  resize: vertical;
  min-height: 90px;
  max-height: 200px;
}

/* ---------- VALIDACIÓN ---------- */
.campo-valido input, .campo-valido select, .campo-valido textarea {
  border-color: #2f9e44;
  box-shadow: 0 0 0 3px rgba(47, 158, 68, 0.1);
}

.campo-error input, .campo-error select, .campo-error textarea {
  border-color: #e03131;
  box-shadow: 0 0 0 3px rgba(224, 49, 49, 0.1);
}

.error-msg {
  font-size: 11px;
  color: #e03131;
  font-weight: 500;
  min-height: 15px;
}

.hint-msg {
  font-size: 11px;
  color: var(--brand-secondary-light);
}

.char-count {
  font-size: 11px;
  color: var(--brand-secondary-light);
  text-align: right;
}

/* ---------- SIGNOS VITALES ---------- */
.vitales-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 14px;
}

.vital-card {
  background: var(--brand-beige);
  border-radius: 10px;
  padding: 14px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  border: 2px solid transparent;
  transition: border-color 0.2s;
}

.vital-card:focus-within { border-color: var(--brand-accent-sage); }

.vital-card.campo-error { border-color: #e03131; }
.vital-card.campo-valido { border-color: #2f9e44; }

.vital-icon {
  font-size: 22px;
  color: var(--brand-primary);
  opacity: 0.7;
  margin-bottom: 4px;
}

.vital-card input {
  background: var(--white);
  font-size: 18px;
  font-weight: 700;
  color: var(--brand-primary);
  padding: 8px 10px;
  text-align: center;
}

/* ---------- SERVICIOS ADICIONALES ---------- */
.servicios-grid {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.servicio-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 14px;
  background: var(--brand-beige);
  border-radius: 8px;
  cursor: pointer;
}

.servicio-item input[type="checkbox"] {
  width: auto;
  flex: 0 0 auto;
}

.servicio-concepto {
  flex: 1;
  font-size: 13px;
  color: var(--brand-secondary);
}

/* ---------- FOOTER ---------- */
.form-footer {
  display: flex;
  justify-content: center;
  padding: 8px 0 32px;
}

.btn-submit {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 13px 32px;
  background: var(--brand-accent-sage);
  color: var(--white);
  border: none;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  letter-spacing: 0.3px;
  box-shadow: 0 4px 14px rgba(96, 127, 112, 0.3);
  transition: background 0.2s, transform 0.15s, box-shadow 0.2s;
}

.btn-submit:hover {
  background: var(--brand-accent-navy);
  transform: translateY(-2px);
  box-shadow: 0 6px 18px rgba(48, 80, 101, 0.35);
}

.btn-submit:disabled { opacity: 0.6; cursor: not-allowed; transform: none; }

/* ---------- RESPONSIVE ---------- */
@media (max-width: 1024px) {
  .contenido { margin-left: 80px; padding: 20px; }
  .personal-grid { grid-template-columns: 1fr 1fr; }
}

@media (max-width: 768px) {
  .dashboard-contenedor { flex-direction: column; }
  .contenido { margin-left: 0 !important; padding: 12px; padding-top: 70px; }
  .campo-cols-2, .campo-cols-3, .id-grid, .personal-grid { grid-template-columns: 1fr; }
  .vitales-grid { grid-template-columns: repeat(2, 1fr); }
  .btn-submit { width: 100%; justify-content: center; }
}

@media (max-width: 480px) {
  .vitales-grid { grid-template-columns: 1fr; }
  .titulo { font-size: 20px; }
}
</style>
